import React from 'react';
import { useMaxViewport } from '../../../core/hooks/use-max-viewport';

type Props = {
  children: React.ReactNode;
};

export const MobileOnly: React.FC<Props> = ({ children }) => {
  const isMobile = useMaxViewport('s');
  return isMobile ? <>{children}</> : null;
};
